<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
    />
    <v-card-title>
      マインクラフトではじめるプログラミング
    </v-card-title>
    <v-card-subtitle>
      マインクラフトをプレイしながら学べるプログラミングの入門書
    </v-card-subtitle>
    <v-card-text>
      プログラミングがはじめてのお子さま向けのマインクラフトでまなぶプログラミングの教科書です<br/>全７章立てで、各章には練習問題もついているので理解度をたしかめながら進めることができます
    </v-card-text>
    <v-card-actions>
      <a href="/textbooks/minecraft/">
        <v-btn
          color="purple"
          text
        >
          無料で読む
        </v-btn>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import MineCraftTextBookImage from '@/assets/img/textbooks/minecraft_programming_for_children.jpg'

export default {
  name: 'VMinecraftProgrammingForChildren',
  data() {
    return {
      cardImage: MineCraftTextBookImage
    }
  }
}
</script>